export const MAX_CHARACTER_LIMIT = 1700;

export const SHORTENED_URL_TOOLTIP_MESSAGE =
  'Mobile carriers block shortened links like the one inserted above because they look like spam. Paste the full web address instead.';

export const CHARACTER_LIMIT_EXCEEDED_MESSAGE = 'Character limit exceeded.';

export const LINK_CANT_BE_SENT_MESSAGE = "This link can't be sent.";

export const ERROR_NOTIFICATION_MESSAGE = "Message can't send due to the following:";
